module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAYElEQVQ4y2NgGBzAoOk/CMdkBv+HsUH4koAJGCOLoWBkAyZ2Wfy/uFEcTJNlgLhd2X/78EQwTbIB/3EAmAG4wCAyQGO6xn9sGGYALnnqGfD/HNAXWDDcCzjkB5EBQxsAANe3j3j7kM/cAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/CF.png
// module id = 1106
// module chunks = 0